(() => {
  const root = document.getElementById('SmashEmailPopup');
  if (!root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';

  const WEBHOOK = root.dataset.webhook;
  const CODE = root.dataset.discountCode || 'SMASH10';
  const DISCOUNT = root.dataset.discountValue || '10';
  const DISMISS_KEY = 'smash_email_popup_dismissed_at';
  const CONVERT_KEY = 'smash_email_popup_converted_at';
  const DISMISS_FOR = 7 * 24 * 60 * 60 * 1000;
  const CONVERT_FOR = 365 * 24 * 60 * 60 * 1000;
  const qs = new URLSearchParams(window.location.search);
  const forceOpen = qs.get('smash_popup') === '1';
  const forceOff = qs.get('smash_popup') === '0';

  let currentStep = 1;
  let favouriteSport = '';
  let previousFocus = null;
  let opened = false;
  let submitted = false;
  let timerId = null;

  const now = Date.now();
  const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
  const convertedAt = Number(localStorage.getItem(CONVERT_KEY) || 0);
  const suppressed = !forceOpen && (
    (dismissedAt && now - dismissedAt < DISMISS_FOR) ||
    (convertedAt && now - convertedAt < CONVERT_FOR)
  );

  if (forceOff || suppressed) return;

  const steps = [...root.querySelectorAll('[data-step]')];
  const emailInput = root.querySelector('[data-popup-email]');
  const error = root.querySelector('[data-popup-error]');
  const submitButton = root.querySelector('[data-popup-submit]');
  const customerForm = root.querySelector('#SmashEmailPopupForm');
  const shopifyTags = root.querySelector('[data-shopify-tags]');
  const sportName = root.querySelector('[data-sport-name]');
  const codeText = root.querySelector('[data-code-text]');
  const copyLabel = root.querySelector('[data-copy-label]');

  if (codeText) codeText.textContent = CODE;

  const track = (name, detail = {}) => {
    try {
      window.dispatchEvent(new CustomEvent(name, { detail }));
    } catch (_) {}
  };

  const slugify = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

  const showStep = (step) => {
    currentStep = step;
    steps.forEach((node) => {
      const active = Number(node.dataset.step) === step;
      node.classList.toggle('is-active', active);
      node.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    window.setTimeout(() => {
      if (step === 2 && emailInput) emailInput.focus({ preventScroll: true });
      if (step === 3) root.querySelector('[data-copy-code]')?.focus({ preventScroll: true });
    }, 40);
  };

  const getFocusable = () => [...root.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
    .filter((el) => el.offsetParent !== null);

  const openPopup = () => {
    if (opened || document.visibilityState === 'hidden') return;
    opened = true;
    previousFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('smash-pop-lock');
    requestAnimationFrame(() => root.classList.add('is-open'));
    window.setTimeout(() => root.querySelector('[data-sport]')?.focus({ preventScroll: true }), 220);
    track('smash:newsletter_popup_open');
  };

  const closePopup = (remember = true) => {
    if (!opened) return;
    if (remember && !submitted) localStorage.setItem(DISMISS_KEY, String(Date.now()));
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('smash-pop-lock');
    window.setTimeout(() => { root.hidden = true; }, 240);
    opened = false;
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
    track('smash:newsletter_popup_close', { step: currentStep });
  };

  root.querySelectorAll('[data-popup-close]').forEach((button) => {
    button.addEventListener('click', () => closePopup(true));
  });

  root.querySelectorAll('[data-sport]').forEach((button) => {
    button.addEventListener('click', () => {
      favouriteSport = button.dataset.sport || 'Other';
      if (sportName) sportName.textContent = favouriteSport.toUpperCase();
      if (shopifyTags) shopifyTags.value = `newsletter, smash-popup, racket-${slugify(favouriteSport)}`;
      showStep(2);
      track('smash:newsletter_popup_sport', { sport: favouriteSport });
    });
  });

  const postToGhl = (email) => {
    if (!WEBHOOK) return Promise.resolve();
    const utm = new URLSearchParams(window.location.search);
    const payload = new URLSearchParams({
      email,
      favorite_sport: favouriteSport || 'Not selected',
      favourite_sport: favouriteSport || 'Not selected',
      source: 'Smash Club Newsletter Popup',
      page_url: window.location.href,
      page_path: window.location.pathname,
      referrer: document.referrer || '',
      discount_code: CODE,
      discount_value: `${DISCOUNT}%`,
      marketing_consent: 'email',
      utm_source: utm.get('utm_source') || '',
      utm_medium: utm.get('utm_medium') || '',
      utm_campaign: utm.get('utm_campaign') || '',
      utm_content: utm.get('utm_content') || '',
      utm_term: utm.get('utm_term') || ''
    });

    return fetch(WEBHOOK, {
      method: 'POST',
      mode: 'no-cors',
      body: payload,
      keepalive: true
    });
  };

  const postToShopify = () => {
    if (!customerForm) return Promise.resolve();
    const data = new FormData(customerForm);
    return fetch(customerForm.action, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      keepalive: true
    });
  };

  customerForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (submitted) return;

    const email = (emailInput?.value || '').trim();
    if (!emailInput || !emailInput.checkValidity() || !email) {
      emailInput?.classList.add('is-error');
      if (error) error.hidden = false;
      emailInput?.focus();
      return;
    }

    emailInput.classList.remove('is-error');
    if (error) error.hidden = true;
    submitted = true;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.querySelector('span').textContent = 'UNLOCKING…';
    }

    localStorage.setItem(CONVERT_KEY, String(Date.now()));
    localStorage.removeItem(DISMISS_KEY);

    Promise.allSettled([postToGhl(email), postToShopify()]).finally(() => {});

    window.setTimeout(() => {
      showStep(3);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.querySelector('span').textContent = 'UNLOCK MY 10% OFF';
      }
    }, 360);

    track('smash:newsletter_popup_submit', { sport: favouriteSport || 'Not selected' });
  });

  root.querySelector('[data-copy-code]')?.addEventListener('click', async () => {
    let copied = false;
    try {
      await navigator.clipboard.writeText(CODE);
      copied = true;
    } catch (_) {
      const field = document.createElement('textarea');
      field.value = CODE;
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      copied = document.execCommand('copy');
      field.remove();
    }

    if (copyLabel) {
      copyLabel.textContent = copied ? 'COPIED ✓' : 'COPY';
      window.setTimeout(() => { copyLabel.textContent = 'COPY'; }, 1800);
    }
  });

  root.querySelector('[data-popup-shop]')?.addEventListener('click', () => {
    track('smash:newsletter_popup_shop', { sport: favouriteSport || 'Not selected' });
    document.body.classList.remove('smash-pop-lock');
  });

  document.addEventListener('keydown', (event) => {
    if (!opened) return;
    if (event.key === 'Escape') {
      closePopup(true);
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const onScroll = () => {
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    if (window.scrollY / maxScroll >= 0.30) {
      window.removeEventListener('scroll', onScroll);
      if (timerId) window.clearTimeout(timerId);
      openPopup();
    }
  };

  if (forceOpen) {
    timerId = window.setTimeout(openPopup, 450);
  } else {
    timerId = window.setTimeout(openPopup, window.innerWidth <= 740 ? 12000 : 10000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.addEventListener('visibilitychange', () => {
    if (!opened && document.visibilityState === 'visible' && forceOpen) openPopup();
  });
})();
